/**
 * Will play audio only if the user has interacted with the page, avoiding a potential error
 *
 * @param {HTMLAudioElement} audio The audio object
 * @returns {Promise<void>}
 */
export async function safePlayAudio(audio) {
  if (navigator.userActivation.hasBeenActive) {
    return audio.play();
  }
}
